import { Component, OnInit, EventEmitter, Input, Output, OnDestroy} from '@angular/core';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { UserService } from 'app/Shared/Services/user.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { HttpErrorResponse } from '@angular/common/http';
import {default as AggoOrderColumnsJSON} from 'app/Shared/Constant/Grid Column Names/AGGO-Columns.json';
import {default as TDETColumnsJSON} from 'app/Shared/Constant/Grid Column Names/TDET-Columns.json';
import {default as LegDetailsColumnsJSON} from 'app/Shared/Constant/Grid Column Names/LegDetails-Columns.json';
import { MessageService,ConfirmationService } from 'primeng/api';
import { Util } from 'app/Shared/Constant/Util';
import { GridService } from 'app/Shared/Services/grid.service';
import { DataService } from 'app/Shared/Services/data.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { ActivatedRoute, Router } from '@angular/router';
import { NewROEService } from 'app/Shared/Component/new-roe-entry/new-roe-entry.service';
import { map } from 'rxjs';
import { CommonModule, LowerCasePipe, NgTemplateOutlet, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { Select } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { MatDividerModule } from '@angular/material/divider';
import { MultiSelectModule } from 'primeng/multiselect';
import { FieldDictionary } from 'app/Pages/cat-dashboard/finra-exception/field-dictionary.model';
import { ToastModule } from 'primeng/toast';
import { DatePickerModule } from 'primeng/datepicker';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
    selector: 'app-new-roe-entry',
    imports: [CommonModule, ButtonModule, MatTooltipModule, TableModule, MatExpansionModule,
        MatChipsModule, MatProgressSpinnerModule, MatChipsModule, MultiSelectModule,
        MatExpansionModule, LowerCasePipe, MatDividerModule, DatePickerModule,
        ConfirmDialogModule, Select, FormsModule,
        DialogModule, NgTemplateOutlet, ToggleSwitchModule, ToastModule],
    templateUrl: './new-roe-entry.component.html',
    styleUrls: ['./new-roe-entry.component.scss'],
    providers: [MessageService]
})
export class NewROEEntryComponent implements OnInit, OnDestroy {
  @Input('rowData') rowData: any;
  @Input() value!: string;
  @Input() index!: number;
  @Input() screenType!: string;
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isMultiEdit!: boolean;
  @Input() firmROEIDList!: Array<string>;
  @Input() correctCodeLength!: number;
  @Input('pageName') pageName: any;
  @Input('reportDate') reportDate : any;
  @Input() existingEventType!: any;
  @Input('selectedEventType') selectedEventType!: any;
  @Input('selectedFileID') selectedFileID:any;
  @Input('selectedGroupName') selectedGroupName:any;
  @Input('selectedID') selectedID:any;
  @Output() closeDropdown: EventEmitter<boolean> = new EventEmitter<boolean>();
 // @Input() pageName: string;
  @Input('errorROEID') errorROEID!:string;
  @Input('CATReporterIMID') CATReporterIMID:any;
  displayNewROEDialog:boolean=true;  
  Edit: boolean = false;
  View: boolean = false;
  displayDialog: boolean = false;
  selectedRow: any = [];
  Editviewcols: any = [];
  BooleanDropDown: any = [{
    label: "true", value: true, description: "True"
  },
  {
    label: "false", value: false, description: "False"
  }];
  newLabel!: string;
  aggoOrdersCols: any;
  aggoOrdersData: any;
  handlingInstructionCols: any;
  handlingInstructionData: any;
  tradeSideDetailsCols: any;
  legDetailsCols:any;
  tradeSideDetailsData: any;
  isClickedOnce: boolean = false;
  selectedRowOriginalJSON: any[] = [];
  selectedRowJSONDataset: any[] = [];
  quickviewcols: any = [];
  EventType!: string;
  tempDataset: any = [];
  TimeDropDown: any;
  handlingInstructionObj:any = {};
  timeInForceObj = {};
  handleInstIndex!: number;
  timeIndex!: number;
  columnJson: any = [];
  checked: boolean = false;
  fdidChecked: boolean = false;
  givenNameForFDID: string = '';
  timeInForceValue: any;
  clearValueJSON: Array<any> = [];
  isLoadingResults: boolean = false;
  timeInForceChoice!: string;
  fieldDictionaryList!: FieldDictionary[];
  groupListDropDown: any = [];
  selectedGroup:any;
  today:any;
  skipFields:any=['rsmsStatus','firmROEID','errorROEID','updateDate','lastUpdatedBy','createDate','errorCodeList'];
  requiredFields:any = [];
  nullRequiredFields:any = [];
  routedPageName:any;
  selectedReportDate:any;
  isDateFomratCorrect:boolean=true;
  errorMessage:any;
  isDateTimeFomratCorrect:boolean=true;
  @Input() groupName!: any;
  validMultilegEventTypes: any = ['MLOR'];
  ROEJSONFieldNames: any = ['timeInForce', 'handlingInstructions'];
  constructor(private emitterService: EmitterService,
    private UrlsService: UrlsService,
    private messageService: MessageService,
    public UserService: UserService, 
    private gridService: GridService, 
    public dataService:DataService,
    private SharedHttpClientService: SharedHttpClientService,
    private confirmationService: ConfirmationService,
    public constantService: ConstantService,
    public userService:UserService,
    private route: ActivatedRoute,
    private router:Router,
    public newROEService:NewROEService,
    private datePipe: DatePipe) {
    this.aggoOrdersCols = AggoOrderColumnsJSON;
    this.aggoOrdersData = [];
    this.tradeSideDetailsCols = TDETColumnsJSON;
    this.handlingInstructionCols = this.userService.handlingInstructionsJSON;
    this.legDetailsCols = LegDetailsColumnsJSON;
    this.tradeSideDetailsData = [];  
  }

  ngOnInit() {   
    this.isLoadingResults = false;
    this.Edit=true;
    this.displayDialog = true;
    this.isClickedOnce = false;
    this.closeDialog.emit(false);
    this.selectedReportDate = this.reportDate;
    this.reportDate =  this.UserService.getyyyyMMddDateFormate(this.getReportDate(new Date()));
    this.EventType = this.selectedEventType;

    if(this.rowData != undefined && this.rowData.length ==1){
      this.rowData = this.rowData[0];
      let timeInForce:any;

      if(this.rowData['timeInForce'] != undefined && this.rowData['timeInForce'].toString().trim().length > 0 && (this.existingEventType != undefined && !this.existingEventType.startsWith("ML")) ){
        if(typeof this.rowData['timeInForce'] == "string"){
          timeInForce = JSON.parse(this.rowData['timeInForce'].toString());
        }
        this.timeInForceValue = timeInForce[Object.keys(timeInForce)[0]];
        this.newLabel=Object.keys(timeInForce)[0];
      }
    } 
     
    this.getGroupList().subscribe(response => {
      let result = response;
      this.groupListDropDown = [];
      let DataSet: any[] = result.Data;
      if (DataSet && DataSet.length > 0) {
        for (let i = 0; i < DataSet.length; i++) {
          this.groupListDropDown.push({ label: DataSet[i].GroupName, value: DataSet[i].GroupName });
        }
      }
      this.isLoadingResults = false;
      this.getCATEditOriginalJSON(this.value, this.index, this.rowData); 
    });
    this.getAggoOrdersColumns();
    this.getTDETColumns();
    this.getLegDetailsColumns();
    this.setDefaultValues();

    if(this.selectedEventType != undefined && this.selectedEventType != ''){
    this.getRequiredFields(this.selectedEventType).subscribe(data=>{
      this.requiredFields = data.data;
    });}
  } 

  getOrignalJSONByType(url:any, data:any, isROEViewer:boolean) {
    this.isLoadingResults=true;
    this.SharedHttpClientService.post(this.UrlsService.setAPIURl(url), data)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (dataset:any) => {
          let data: any = dataset;
        this.isLoadingResults=false;
        if(data.json.length > 0 && data.json[0].length > 0) {          
          this.selectedRowJSONDataset[0] = JSON.parse(data.json[0]);
            this.Editviewcols.map((element:any)=>{
              if(element.field_Name != 'type' && element.field_Name != 'reportDate' && element.field_Name != 'firmROEID' && element.field_Name != 'errorROEID') {
                if(this.selectedRowJSONDataset[0][element.field_Name] != undefined){
                  element.value = (this.ROEJSONFieldNames.includes(element.field_Name) ? this.getValueofField(element.field_Name) : this.selectedRowJSONDataset[0][element.field_Name]);
                }
              }
            })
        }
        },
        error: (err: HttpErrorResponse) => {
          this.isLoadingResults=false; 
        }
      });
  }

  getReportDate(today:any) {
    if (today.getDay() == 6) {
      today.setDate(today.getDate() + 2);
    } else if (today.getDay() == 7) {
      today.setDate(today.getDate() + 1);
    }
    return today;
  }

  getAggoOrdersColumns() {
    let column: any = this.aggoOrdersCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.aggoOrdersCols = this.gridService.getGridColumns(column);
    }
  }

  getTDETColumns() {
    let column: any = this.tradeSideDetailsCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.tradeSideDetailsCols = this.gridService.getGridColumns(column);
    }
  }

  getLegDetailsColumns() {
    let column: any = this.legDetailsCols;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.legDetailsCols = this.gridService.getGridColumns(column);
    }
  }

  getCATEditOriginalJSON(value:any, index:any, rowData: any) {    
      let data = {
        "mpid":this.UserService.getActiveMPID(),
        "eventType":this.EventType,
      }    
      this.setDefaultValues();
      this.prepareJsonData(value, index, rowData,false);
  }

  clearData(){
    this.selectedRowJSONDataset[0] = {
      "type":this.EventType, 
      "mpid": this.UserService.getActiveMPID(),
      "CATReporterIMID":this.UserService.getActiveMPID(),
      "actionType":"NEW",
      "reportDate":this.reportDate
      };   
      this.timeInForceValue = '';
      this.timeInForceObj = [];
      this.newLabel = '';
      // To set default value for timeInForce
      this.selectedRowJSONDataset[0]["timeInForce"]={"DAY": ""};     

      this.prepareJsonData(null, null, this.selectedRowJSONDataset[0],true);
  }

  closePage(){
    if(this.routedPageName === 'Finra-Exception'){
      this.router.navigate(["pages/CAT/Finra-Exception"]);
    } else if(this.routedPageName === 'CAT-Exception'){
      this.router.navigate(["pages/CAT/CAT-Exception"]);
    } else if(this.routedPageName === 'CAT-ROE-Viewer'){
      this.router.navigate(["pages/CAT/CAT-ROE-Viewer"]);
    }
  }

  getOrignalJSON(rowData:any,value:any, index:any, url:any, data:any, isROEViewer:boolean) {   
    this.selectedRowJSONDataset[0] = [];
    this.prepareJsonData(value, index, rowData,false);
  }
  prepareJsonData(value: any, index: any, rowData:any, isClearValue:boolean) {
    if (!this.isMultiEdit) {
      this.selectedRow = [];
      this.selectedRow[0] = (rowData);
    }
    this.quickviewcols = [];
    let tempRow: any = this.selectedRow[0];
    this.EventType = this.EventType;
    this.prepareQuickviewPanel(); 

   
      if (this.EventType != "--" && this.EventType != "" && this.EventType != " " && this.EventType != null) {
        this.Editviewcols = [];

        this.tempDataset = this.cloneData(this.selectedRowJSONDataset[0]);/* *** set old data for backup */
        if(this.existingEventType == undefined || (this.existingEventType.toUpperCase().startsWith("ML") && !this.validMultilegEventTypes.includes(this.EventType.toUpperCase())) || isClearValue || this.selectedID == undefined
        || rowData.length > 1){
          return;
        } 

        let data = {
          "CATReporterIMID":this.CATReporterIMID,
          "eventType": this.existingEventType.toLowerCase(),
          "firmROEID": this.selectedID,
          "reportDate": this.selectedReportDate,
          "pageName": this.pageName,
          "groupName":this.selectedGroupName,
          "fileID": parseInt(this.selectedFileID),
          "errorROEID":this.errorROEID
        }
        this.getOrignalJSONByType(APIURL.GET_OriginalJSON_ForEdit_Screen, data, true);  
        this.displayDialog = true;
      }
  }
  
  prepareQuickviewPanel() {
    this.quickviewcols = [];
    if(this.EventType != undefined){
      this.quickviewcols=this.gridService.prepareQuickviewPanel(this.EventType.toUpperCase());
    }
  }

  cloneData(tempRow: any, action?: string) {
    this.timeInForceObj = tempRow ? tempRow.timeInForce : null;
    this.handlingInstructionObj = tempRow && tempRow.handlingInstructions !== null && tempRow.handlingInstructions !== "" && tempRow.handlingInstructions !== undefined ? JSON.stringify(tempRow.handlingInstructions) : null;
    this.Editviewcols = [];
    let len = Object.keys(this.quickviewcols).length;
    let FailureDescription = "";
    for (let i = 0; i < Object.keys(this.quickviewcols).length; i++) {      
      let tempKeyName = this.quickviewcols[i]?.mappingkey;
      let isError = false;
      if (Util.isDefinedAndNotNull(tempKeyName)) {
        let error_code_object: any;
        error_code_object = this.UserService.getFieldDictionaryObject(tempKeyName);
        if (error_code_object) {
          let keyofValue = error_code_object["field_Name"];
          this.quickviewcols[i].datatype = error_code_object['data_Type'];
          this.Editviewcols[i] =
            {
              "ui_Field_Name": error_code_object["ui_Field_Name"],
              "field_Name": error_code_object["field_Name"],
              "default_Value": error_code_object["default_Value"],
              "value": this.getValueofField(keyofValue),
              "datatype": this.quickviewcols[i].datatype,
              "time": "00:00:00",
              "display": this.quickviewcols[i].display,
              "db_columnname": this.quickviewcols[i].db_columnname,
              "dropdowntype": error_code_object["dropdowntype"],
              "dropdownvalue": this.getFilteredValueOfField(error_code_object), // Search & Assign Dynamic DB stored Dropdown Values for Every Field
              "description": error_code_object["description"],
              "error_Code": error_code_object["error_Code"],
              "error_Code_Description": error_code_object["error_Code_Description"],
              "isException": isError,
              "isDisable": this.quickviewcols[i].disabled,
            }
          let datatype: string = error_code_object["data_Type"];
          if (datatype == 'Choice') {
            this.Editviewcols[i].datatype = "Choice";
          }
        }
        else {
          this.Editviewcols[i] =
            {
              "ui_Field_Name": this.quickviewcols[i].ui_columnname,
              "field_Name": this.quickviewcols[i].mappingkey,
              "default_Value": "",
              "value": this.getValueofField(this.quickviewcols[i].mappingkey),
              "datatype": this.quickviewcols[i].datatype,
              "time": "00:00:00",
              "display": this.quickviewcols[i].display,
              "db_columnname": this.quickviewcols[i].db_columnname,
              "dropdowntype": this.quickviewcols[i].dropdown,
              "dropdownvalue": this.quickviewcols[i].dropdownvalue,
              "description": "",
              "error_Code": "",
              "error_Code_Description": "",
              "isException": isError,
              "isDisable": this.quickviewcols[i].disabled
            }      
        }
      }
      if(this.Editviewcols[i]?.ui_Field_Name === 'groupName'){
        this.Editviewcols[i].datatype = 'Choice';
        this.Editviewcols[i].dropdowntype = 'SingleSelect';
        this.Editviewcols[i].dropdownvalue = this.groupListDropDown;
        this.Editviewcols[i].isDisable = false;        
      }
      if(this.Editviewcols[i]?.ui_Field_Name === 'reportDate'){
        this.Editviewcols[i].isDisable = false;
      }   

      if (this.isMultiEdit) {
        if (this.Editviewcols[i]?.ui_Field_Name === 'sellDetails' || this.Editviewcols[i]?.ui_Field_Name === 'buyDetails' 
        || this.Editviewcols[i]?.ui_Field_Name === 'clientDetails' || this.Editviewcols[i]?.ui_Field_Name === 'legDetails' ||  this.Editviewcols[i]?.ui_Field_Name === 'firmDetails') {
          this.Editviewcols[i]['value'] = [{}];
        } else if (this.Editviewcols[i]?.ui_Field_Name === 'timeInForce') {
          if (this.selectedRowJSONDataset[0][this.Editviewcols[i]?.ui_Field_Name] !== undefined &&
             this.selectedRowJSONDataset[0][this.Editviewcols[i]?.ui_Field_Name] !== null) {
            this.newLabel = this.getObjectKey(this.selectedRowJSONDataset[0][this.Editviewcols[i]?.ui_Field_Name]);
            this.timeInForceValue = undefined;
          }
        } else if (this.Editviewcols[i]?.ui_Field_Name === 'handlingInstructions') {
          this.handlingInstructionData = [{}];
          this.handlingInstructionCols = [];
        } else if (this.Editviewcols[i]?.ui_Field_Name === 'type' || this.Editviewcols[i]?.ui_Field_Name === 'CATReporterIMID' ||
        this.Editviewcols[i]?.ui_Field_Name === 'reportDate' || this.Editviewcols[i]?.ui_Field_Name === 'groupName') {
          this.Editviewcols[i]['value'] =  this.Editviewcols[i]['value'] 
        }
        else{
          this.Editviewcols[i]['value'] = null;
        }
      }      
    }        
    return this.Editviewcols;
  }

  getValueofField(fieldName: string) {
     if (fieldName === 'handlingInstructions') {
      let obj = this.selectedRowJSONDataset[0][fieldName]
      let result = obj!== undefined? Object.keys(obj).map(function (key) {
        return [(key), obj[key]];
      }): [];
      this.selectedRowJSONDataset[0][fieldName] = this.selectedRowJSONDataset[0][fieldName] !==undefined ? [this.selectedRowJSONDataset[0][fieldName]] : [{}];
      this.handlingInstructionCols = this.gridService.getGridColumnsHasValues(result);
      this.handlingInstructionData =   this.selectedRowJSONDataset[0][fieldName];
    } else if (fieldName === 'timeInForce') {
      if (this.selectedRowJSONDataset[0][fieldName] !== undefined && this.selectedRowJSONDataset[0][fieldName] !== null) {
        this.timeInForceValue = Object.keys(this.selectedRowJSONDataset[0][fieldName]).length > 0 ? this.selectedRowJSONDataset[0][fieldName][this.getObjectKey(this.selectedRowJSONDataset[0][fieldName])] : this.selectedRowJSONDataset[0]['reportDate'].replaceAll("-", "");
        this.newLabel = Object.keys(this.selectedRowJSONDataset[0][fieldName]).length > 0 ? this.getObjectKey(this.selectedRowJSONDataset[0][fieldName]): this.selectedRowJSONDataset[0][fieldName].dropdownValue[0]["value"];
      }  
    } else if(fieldName === 'aggregatedOrders' || fieldName === 'legDetails'){
      return [{}];
    } else {
    return this.selectedRowJSONDataset[0][fieldName];
  }
      // return this.selectedRowJSONDataset[0][fieldName];
  }

  /* Get Filtered Dropdown Values for respective Fields (e.g. - side - ME* Event Types - B/SL/SS/SX & MO* Event Types - B/S) */
  getFilteredValueOfField(fieldObject: any) {
    let fieldOptions = fieldObject.dropdownvalue;
      if(fieldObject.field_Name === "side") {
        if(this.EventType.toLocaleLowerCase().startsWith("me")) {
          fieldOptions = fieldObject.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMEEventTypes.includes(rowObj.value));
        } else if (this.EventType.toLocaleLowerCase().startsWith("mo")) {
          fieldOptions = fieldObject.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMOEventTypes.includes(rowObj.value));
        }
      }
    return fieldOptions;
  }

  save() {
    this.givenNameForFDID = '';
    let handlingObj: any;
    let  handlingArr:any= [];

    /* Form necessary Field Validation */
      if(!this.validateEssentialFormFields()) {
        return false;
      }
    /* End of Form necessary Field Validation */

    this.Editviewcols.filter((element:any, index:any) => {
      if(element.field_Name === 'handlingInstructions' && this.handlingInstructionData) {
        this.Editviewcols[index].value = {};    
        this.handlingInstructionCols.forEach((element:any) => {
         let keys = Object.keys(this.handlingInstructionData[0]);
         if(this.handlingInstructionData[0] !== "{}" && keys.indexOf(element.header) >= 0)
         {
          handlingArr.push(this.userService.getHandlingInstructionValue(element,this.Editviewcols[index], this.handlingInstructionData[0]));
         }
        });
        if(handlingArr.length>0){
          handlingObj = Object.assign.apply(Object, handlingArr); // Array of obj into one obj
          }
          this.Editviewcols[index].value = this.handlingInstructionCols.length > 0 && handlingObj !== undefined ? this.removeNullValueObj(handlingObj) : null;  
        } else if (element.field_Name === 'timeInForce') {
        this.newLabel = this.newLabel === '' || this.newLabel == undefined ? this.Editviewcols[index].dropdownvalue[0]["label"]: this.newLabel;
        this.Editviewcols[index].value = this.timeInForceValue ? { [this.newLabel]: (['GTT'].indexOf(this.newLabel) >= 0 ? this.timeInForceValue : JSON.parse(this.timeInForceValue)) } : undefined;
        } else if (element.field_Name === 'buyDetails' || element.field_Name === 'sellDetails' ||
      element.field_Name === 'clientDetails' || element.field_Name === 'firmDetails' || element.field_Name === 'legDetails') {
      this.Editviewcols[index].value = Object.keys(this.removeNullValueObj(this.Editviewcols[index].value == undefined || this.Editviewcols[index].value[0])).length === 0 ? null : this.Editviewcols[index].value;
    } else if (element.field_Name === 'aggregatedOrders') { 
      this.Editviewcols[index].value = this.Editviewcols[index].value !== null && this.Editviewcols[index].value !== undefined && Object.keys(this.Editviewcols[index].value[0]).length === 0 ? null : this.Editviewcols[index].value;
    } else if(element.field_Name == 'firmDesignatedID' && this.Editviewcols[index].value !== null && this.Editviewcols[index].value !== undefined){
      this.Editviewcols[index].value =  this.Editviewcols[index].value.trim().length == 0 ? null : this.Editviewcols[index].value.trim(); 
    }
    });

    if(this.isMultiEdit) {
      this.multiEditSave();
    } else {
      this.CallUpadteAPI();
    }

    this.displayDialog = false;
    this.handlingInstructionObj = {};
    this.dataService.roeSelectedRecords=[];
    this.timeInForceObj = {};
    this.selectedRow = [];
    return true;
  }

  validateEssentialFormFields() {
    let updatedJSONObject: any = {};

    this.Editviewcols.forEach((element:any, index:any) => {
      if (element.value !== null && element.value !== "" && element.value !== undefined) {
        updatedJSONObject[element.field_Name] = this.Editviewcols[index].value;
      }
    });

    /* Validation for Total Multileg Details */
      if(updatedJSONObject.hasOwnProperty('numberOfLegs') && (updatedJSONObject.numberOfLegs!==null && updatedJSONObject.numberOfLegs!==undefined && updatedJSONObject.numberOfLegs!=='' && updatedJSONObject.numberOfLegs!==0) && updatedJSONObject.hasOwnProperty('legDetails') && (updatedJSONObject.numberOfLegs !== updatedJSONObject.legDetails.length)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter matching info for Leg Details and NumberOfLegs' });
        this.isClickedOnce = false;
        return false;
      } else if(updatedJSONObject.hasOwnProperty('numberOfLegs') && updatedJSONObject.numberOfLegs > 0 && updatedJSONObject.hasOwnProperty('legDetails') && !this.dataService.hasAnyEmptyObjectInObjectArray(updatedJSONObject.legDetails)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter data in All Leg Details' });
        this.isClickedOnce = false;
        return false;
      }
    /* End of Validation for Total Multileg Details */

    /* Validation for AggoOrder Details */
      if(updatedJSONObject.hasOwnProperty('aggregatedOrders') && updatedJSONObject.aggregatedOrders.length > 0 && Object.keys(this.dataService.removeNullValueObj(updatedJSONObject.aggregatedOrders[0])).length > 0 && (updatedJSONObject.hasOwnProperty('representativeInd') || !updatedJSONObject.hasOwnProperty('representativeInd')) && (updatedJSONObject.representativeInd===null || updatedJSONObject.representativeInd===undefined || updatedJSONObject.representativeInd==='')) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter RepresentativeInd relevant with Aggo Details' });
        this.isClickedOnce = false;
        return false;
      } else if(updatedJSONObject.hasOwnProperty('aggregatedOrders') && updatedJSONObject.aggregatedOrders.length > 1 && !this.dataService.hasAnyEmptyObjectInObjectArray(updatedJSONObject.aggregatedOrders)) {
        this.messageService.add({ severity: 'error', summary: 'Failed Message', detail: 'Please enter data in All Aggo Details' });
        this.isClickedOnce = false;
        return false;
      }
    /* End of Validation for AggoOrder Details */

    return true;
  }

  multiEditSave() {
    let multiEditPayload = {
      user:this.UserService.getUserName(),
      mpid: this.UserService.getActiveMPID(),
      updatedJSON: this.removeNoValueFieldsFromEditviewcols(),
      firmROEIDList: this.firmROEIDList,
      eventType: this.EventType
    }
    let msg = '';
      msg = 'Do you want to save changes for '+ this.correctCodeLength +' records?';
    this.confirmationService.confirm({
      message: msg,
      key: 'confirmationDialogForEdit',
      accept: () => {
        this.isLoadingResults=true;
        this.SharedHttpClientService.post(this.UrlsService.setAPIURl(APIURL.CAT_ROE_Viewer_MultiEdit), multiEditPayload)
      .pipe(map((response: Response) => {
        return response.text();
      }))
      .subscribe({
        next: (Element:any) => {
          this.isLoadingResults=false;
            this.tempDataset = [];
            this.Edit = false;
            this.isClickedOnce = false;
            this.handlingInstructionData = [];
            this.messageService.add({ severity: 'success', summary: 'Update Success Message', detail: 'Record Updated Successfully' });
            this.closeDialog.emit(true);
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Update', detail: 'Record Update Failed!' });
              this.isClickedOnce = false;
              this.isLoadingResults=false;
              this.closeDialog.emit(false);
        }
        });
      },
      reject: () => {
        this.isClickedOnce = false;
      }
    });
  }

  clearValue(editRow:any) {    
    editRow.value = '';
    if(editRow['ui_Field_Name'] === "timeInForce"){
      this.timeInForceValue = '';
    } 
  }
  removeNoValueFieldsFromEditviewcols() {
    let object: any = {};
    this.Editviewcols.forEach((element:any, index:any) => {
      if (element.value !== null && element.value !== "" && element.value !== undefined) {
        object[element.field_Name] = this.Editviewcols[index].value;
      }
    });
    if(this.clearValueJSON.length >= 1) {
      this.clearValueJSON.forEach((element)=> {
        object[element.field_Name] = "";
      });
      /* Remove Blank TimeInForce Value from Updated JSON Object */
      if(object.timeInForce === undefined || object.timeInForce === "" || object.timeInForce === null) {
        delete object.timeInForce;
      }
    }
    return object;
  }
  setEditRowValue(index: number, key: string) {
    /* Receiving updated TimeInForce Value */
      let timeInForceValue = this.userService.getTimeInforceValue(key, this.Editviewcols[index].field_Name, false, this.Editviewcols);
      this.timeInForceValue = timeInForceValue;
    /* End of Receiving updated TimeInForce Value */

    this.Editviewcols[index].value = {
      [key]: timeInForceValue,
    }
  }
  getObjectKey(obj:any) {
    const key = Object.keys((obj))[0];
    return key;
  }

  removeNullValueObj(obj:any) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === "" || obj[key] === null) {
        delete obj[key]
      }
    })
    return obj
  }

  isTimeInForceEmpty(value:any): boolean {
    if (value === undefined || value === null || value === "") {
      return true;
    }
    const keyValue = value[this.getObjectKey(value)];
    return keyValue === undefined || keyValue === null || String(keyValue).trim() === "";
  }
  
  CallUpadteAPI() {
    /* *** Update API Call */
    let object: any = {};
    let tempRow = this.selectedRowJSONDataset[0];
    this.Editviewcols.forEach((element:any, index:any) => {
      if (element.value !== null && element.value !== "" && element.value !== undefined) {
        tempRow[element.field_Name] = this.Editviewcols[index].value; 
      }
    });
    let j=0;
    this.nullRequiredFields = [];

    for(let i=0; i < this.requiredFields.length;i++){
      if(this.requiredFields[i].toLowerCase()=="firmroeid" || 
      this.requiredFields[i].toLowerCase()=="fileid"){ 
        continue;
      }

      const requiredValue = tempRow[this.requiredFields[i]];
      if(requiredValue == undefined ||
      (typeof requiredValue === 'string' && requiredValue.trim() === "") ||
      (this.requiredFields[i].toLowerCase()=="timeinforce" && this.isTimeInForceEmpty(requiredValue))){
        this.nullRequiredFields[j] = this.requiredFields[i];
        j++;        
      }
    }
    if(this.nullRequiredFields.length > 0){
      this.messageService.add({ severity: 'error', summary: 'Fill All Required Fields', detail: 'Fill following Required Fields:'+this.nullRequiredFields.join(',\n'), life:6000 });
        return;
    }

    if(!this.isDateFomratCorrect){
      this.messageService.add({ severity: 'error', summary: 'Invalid Date format', detail: 'Please enter date in correct format : yyyyMMddT000000' });
      return;
    }

    if(!this.isDateTimeFomratCorrect){
      this.messageService.add({ severity: 'error', summary: 'Invalid DateTime format', detail: 'Please enter date in correct format : yyyyMMddTHHmmssSSSSSS' });
      return;
    }

    this.Editviewcols.forEach((element:any, index:any) => {
      if (element.value !== null && element.value !== "" && element.value !== undefined) {
        object[element.field_Name] = this.Editviewcols[index].value;
        tempRow[element.field_Name] = this.Editviewcols[index].value;
      } 
      else {
        tempRow[element.field_Name] = null;
      }
    });

    let data = {
          "type": this.EventType,
          "mpid": this.UserService.getActiveMPID(),
          "reporterID": this.UserService.getActiveMPID(),
          "actionType": "NEW",
          "reportDate": this.reportDate,
          "groupName": tempRow['groupName'],
          "json": object,
          "user": this.UserService.getUserName()
      }
    this.isLoadingResults=true;
    this.SharedHttpClientService.post(this.UrlsService.setAPIURl(APIURL.New_ROE_Entry_Save), data)
    .subscribe({
      next: (Element:any) => {
        this.isLoadingResults=false;
      let data: any = Element.data;
      if (data == "Insert Failed"){
        this.messageService.add({ severity: 'error', summary: 'Update Failed Message', detail: 'Record Update Failed!', life: 3000 });
        this.userService.logUserActivity('Inserting new ROE failed', 'CAT', {
          'Text1': 'Inserting new ROE failed '+this.selectedRowOriginalJSON +' Event type:'+ this.EventType,
          'Text2': ' by user ' + this.UserService.getUserName()
        });
      } 
        if (data == "Record added successfully") {
        tempRow = this.selectedRowOriginalJSON;
        tempRow['rsmsStatus'] = 'U';
        this.selectedRow[0] = tempRow;
        this.tempDataset = [];
        this.Edit = false;
        this.isClickedOnce = false;
        this.handlingInstructionData = [];
        this.messageService.add({ severity: 'success', summary: 'Record Inserted Success Message', detail: 'Record Inserted Successfully' });
        this.userService.logUserActivity('Inserting new ROE', 'CAT', {
          'Text1': 'Inserting new ROE Entry'+this.selectedRowOriginalJSON +' Event type:'+ this.EventType,
          'Text2': ' by user ' + this.UserService.getUserName()
        });
        this.closeDialog.emit(true);
        this.Edit = false; 
        this.clearData();
      }else{
        this.messageService.add({ severity: 'error', summary: 'Record Insert failure Message', detail: 'Record Insert Failed:Don\'t remove required field' });
      }      
      },
      error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Record Insert failure Message', detail: 'Record Insert Failed' });
        this.userService.logUserActivity('Inserting new ROE failed', 'CAT', {
          'Text1': 'Inserting new ROE failed '+this.selectedRowOriginalJSON +' Event type:'+ this.EventType,
          'Text2': ' by user ' + this.UserService.getUserName()
        });
        this.isClickedOnce = false;
        this.isLoadingResults=false;
        this.closeDialog.emit(false);
      }
    });

  }

  getFDID(index: number) {
    this.isLoadingResults=true;
    this.SharedHttpClientService.post(
      this.UrlsService.setAPIURl(
        APIURL.CAT_Exception_Get_FDID
        ), {
          "mpid": this.UserService.getActiveMPID(),
          "givenName": this.givenNameForFDID
      })
      .subscribe({
        next: (data:any) => {
          this.isLoadingResults=false;
            this.Editviewcols[index].value = data.Data.length > 0? data.Data[0].generatedFDID: null;
            if(this.Editviewcols[index].value === null) {
              this.messageService.add({ severity: 'error', summary: 'Not Found', detail: 'Firm Designated ID not found for given name' });
            } else {
              this.messageService.add({ severity: 'success', summary: 'record Found', detail: 'Updated Firm Designated ID' });
            }
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'warn', summary: 'Not Found', detail: 'Firm Designated ID not found for given name' });
          this.isLoadingResults=false;
        }
      });
  }
  ngOnDestroy() {

  }
  getChildColumns(fieldName:any){
    if(["legDetails"].includes(fieldName)){
      /* Provide Drop Down Field Values to respective Fields (Side/OpenCloseIndicator) */
      if(this.legDetailsCols.length > 0) {
        for(let i=0; i < this.legDetailsCols.length; i++) {
          let Field_Dictionary_Object;
          if(this.legDetailsCols[i]["dropdown"].toLowerCase()==="yes") {
            Field_Dictionary_Object = this.userService.getFieldDictionaryObject(this.legDetailsCols[i]["field"]);
            this.legDetailsCols[i]["dropdownvalue"] = Field_Dictionary_Object.dropdownvalue;
          }
        }
      }

      return this.legDetailsCols;
    }
   return this.tradeSideDetailsCols;
 }

  /* Get Dropdown Values for LegDetails/BuyDetails/SellDetails/FirmDetails/ClientDetails etc. Dropdown Fields */
  getROEDetailsFieldDropdownValues(editRow: any, col: any, tradeSideRowData: any) {
    let fieldOptions = col.dropdownvalue;
      if(["legDetails"].includes(editRow.field_Name)) {
        if(["side"].includes(col.field)) {
          if(tradeSideRowData.symbol && tradeSideRowData.symbol !== null && tradeSideRowData.symbol.length > 0 && (!tradeSideRowData.optionID || tradeSideRowData.optionID === null)) {
            fieldOptions = col.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMEEventTypes.includes(rowObj.value));
          } else if(tradeSideRowData.optionID && tradeSideRowData.optionID !== null && tradeSideRowData.optionID.length > 0 && (!tradeSideRowData.symbol || tradeSideRowData.symbol === null)) {
            fieldOptions = col.dropdownvalue.filter((rowObj: any) => this.constantService.validSidesMOEventTypes.includes(rowObj.value));
          }
        }
      }
    return fieldOptions;
  }

  getGroupList() {
    this.isLoadingResults = true;
    return this.SharedHttpClientService.post(this.UrlsService.setAPIURl(APIURL.CAT_Get_Group_List),
      {
        validationType: "CAT",
        mpid: this.userService.getActiveMPID(),
        reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate)
      });            
  }

  getRequiredFields(type:string) {
    this.isLoadingResults = true;
    return this.SharedHttpClientService.post(this.UrlsService.setAPIURl(APIURL.Get_Required_Fields_BY_Type),
      {
       "type": type
      });            
  }

  setDefaultValues(){
    this.selectedRowJSONDataset[0] = {
      "type":this.EventType,      
      "CATReporterIMID":this.UserService.getActiveMPID(),
      "actionType":"NEW",
      "reportDate":this.reportDate,
      "custDspIntrFlag":false,
      "affiliateFlag":false,
      "negotiatedTradeFlag":false,
      "representativeInd":"N",
      "solicitationFlag":false,
      "groupName":this.selectedGroupName
      };
      if(this.rowData.length==0){
        this.selectedRowJSONDataset[0]["timeInForce"]={"DAY": ""}     
      } 
  }

  checkDateFormat(checked_date:any){
    if(checked_date.field_Name.toLowerCase().indexOf('keydate') > 0){
      if(!this.constantService.dateTimeRegexCheck(checked_date.value)){
        this.isDateFomratCorrect=false;
        this.messageService.add({ severity: 'error', summary: 'Invalid Date', detail: 'Please enter date in correct format : yyyyMMddT000000' });
      } else{
        this.isDateFomratCorrect=true;
      }  
    } else if(checked_date.field_Name.toLowerCase().indexOf('timestamp') > 0){
      if(!this.constantService.timeStampRegexCheck(checked_date.value)){
        this.isDateTimeFomratCorrect=false;
        this.messageService.add({ severity: 'error', summary: 'Invalid Date', detail: 'Please enter date in correct format : yyyyMMddTHHmmssSSSSSS' });
      } else{
        this.isDateTimeFomratCorrect=true;
      }  
    }   
  }

  getDateTimeTFormate(keyName:any, datetime:any, index:any){
    try {
      this.Editviewcols[index].value = this.userService.getDateTimeTFormate(datetime, keyName);
      if (this.userService.timeStampErrorField == keyName) {
        this.messageService.add({ severity: 'error', summary: 'Invalid DateTime', detail: 'Enter the date and time in as - '+this.userService.getDateTimeTFormatePattern(keyName)+' '+this.Editviewcols[index].value });
      }
    } catch (e) {
      this.userService.timeStampErrorField = keyName;
      this.messageService.add({ severity: 'error', summary: 'Invalid DateTime', detail: 'Enter the date and time in as - '+this.userService.getDateTimeTFormatePattern(keyName)+' '+this.Editviewcols[index].value });
    }
  }

  closeDialogBox(){
    this.closeDialog.emit(false);
    this.closeDropdown.emit(true);
    this.rowData=[];
    this.selectedRow=[];
  }

  singleEditFormateDatetime(datatype:any, type:any, i:any) {
    if (type == 'date') {
      let temp: string | any = this.datePipe.transform(this.Editviewcols[i].value, "yyyy-MM-dd");
      let date: string = ((temp.replace("-", "")).replace("-", "")).replace("-", "");
      if (datatype == "DateTime") {
        let temptime: string = this.Editviewcols[i].time;
        if (temptime == undefined) {
          this.Editviewcols[i].value = date.concat("000000000");
        } else {
          let time: string = ((temptime.replace(":", "")).replace(":", "")).replace(":", "");
          this.Editviewcols[i].value = date.concat(time);
        }
      }
      else if (datatype == "Date" || datatype == "DateRange") {
        this.Editviewcols[i].value = date.concat("000000000");
      }
    } if (type == 'time') {
      let temp: string | any = this.Editviewcols[i].value;
      let date: string = temp.substring(0, 8);
      let temptime: string = this.Editviewcols[i].time;
      let time: string = ((temptime.replace(":", "")).replace(":", "")).replace(":", "");
      this.Editviewcols[i].value = date.concat(time);
    }
  }

}